<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 0C23.2836 0 30 6.71642 30 15C30 23.2836 23.2836 30 15 30H4.44963C2.00249 30 0 27.9975 0 25.5504V15C0 6.71642 6.71642 0 15 0ZM16.7289 21.2966C16.7289 22.0118 17.1922 22.6213 17.8358 22.842V24.7575H12.1642V22.842C12.8078 22.6213 13.2711 22.0118 13.2711 21.2966V13.7873C13.2711 13.0752 12.8078 12.4627 12.1642 12.2419V10.3265H16.7289C16.7289 13.9832 16.7289 17.6399 16.7289 21.2966ZM15 5.24254C16.023 5.24254 16.8532 6.07276 16.8532 7.09577C16.8532 8.12189 16.023 8.95212 15 8.95212C13.977 8.95212 13.1468 8.12189 13.1468 7.09577C13.1468 6.07276 13.977 5.24254 15 5.24254Z"
    />
  </svg>
</template>
